import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Master Refresh — one button that re-syncs anything that could be stale across the app:
// clears computed caches, re-pulls the Sleeper player DB, re-detects every league's format
// from live settings, and kicks off a full market-value re-blend. Hit it whenever something
// looks off and the app self-heals.
export default function MasterRefresh() {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (busy) return;
    setBusy(true);
    const t = toast.loading("Refreshing everything…");
    try {
      const { data } = await api.post("/refresh");
      const bits = [];
      if (data.formats_updated) bits.push(`${data.formats_updated} league format${data.formats_updated > 1 ? "s" : ""}`);
      if (data.players_synced) bits.push("player database");
      if (data.caches_cleared) bits.push("analytics caches");
      toast.success("Refresh complete", {
        id: t,
        description: `Synced ${bits.join(", ") || "your data"}. Market values are re-blending in the background — reloading…`,
      });
      setTimeout(() => window.location.reload(), 1400);
    } catch (e) {
      toast.error("Refresh failed", { id: t, description: "Please try again in a moment." });
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      data-testid="master-refresh-button"
      title="Master Refresh — re-sync leagues, values & caches if anything looks off"
      className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-[var(--border)] text-[var(--text-2)] hover:text-[var(--accent)] hover:border-[var(--accent)] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
    >
      <RefreshCw className={`w-4 h-4 ${busy ? "spin" : ""}`} />
    </button>
  );
}
